import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ManageMyTeamCTA } from "./ctas";

export const ManageTeamsIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => MANAGE_YOUR_TEAM(strictLocalize),
    getDescription: () => [
      MEMBERS_OF_YOUR_TEAM(strictLocalize),
      TO_CREATE_OR_MANAGE_YOUR_TEAM(strictLocalize),
    ],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ManageMyTeamCTA(strictLocalize);
};

const MANAGE_YOUR_TEAM = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Manage your team",
    description: {
      text: "Title for the answer of Manage teams issue",
    },
  });

const MEMBERS_OF_YOUR_TEAM = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Members of your team can have their own login for your Faire account. You’ll be able to collaborate more efficiently, streamline communication across your orders, and manage team members' roles and permissions.",
  });

const TO_CREATE_OR_MANAGE_YOUR_TEAM = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "To create or manage your team, manage permissions and account ownership, click the button below or read the help center article for more details. You can contact us if you need more assistance.",
  });
